import './glowingtext.css'

export const TypingText = ({ content }) => (
    <div className='typingtext'>
        <p>{content}</p>
    </div>
);
